import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';

const SCROLL_THRESHOLD = 300;

const BackToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > SCROLL_THRESHOLD);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  if (!visible) return null;

  return (
    <Button
      variant="primary"
      className="position-fixed bottom-0 end-0 m-3 rounded-circle shadow"
      style={{ width: 48, height: 48, zIndex: 1050 }}
      onClick={scrollToTop}
      aria-label="Back to top"
    >
      <i className="fas fa-arrow-up" />
    </Button>
  );
};

export default BackToTopButton;
